import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingTierCard = ({ tier, onSelectPlan, featured = false }) => {
  return (
    <div
      className={`relative bg-card border-2 rounded-2xl p-6 transition-all duration-300 ${
        featured
          ? 'border-secondary shadow-xl scale-105'
          : 'border-border hover:border-primary/50 hover:shadow-lg'
      }`}
    >
      {featured && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-secondary text-secondary-foreground text-xs font-semibold rounded-full">
          Most Popular
        </div>
      )}

      <div className="text-center mb-6">
        <div className={`w-16 h-16 mx-auto mb-4 rounded-xl bg-${tier?.color}/10 flex items-center justify-center`}>
          <Icon name={tier?.icon} size={32} color={`var(--color-${tier?.color})`} />
        </div>

        <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
          {tier?.name}
        </h3>

        <p className="text-sm text-muted-foreground mb-4">
          {tier?.description}
        </p>

        <div className="flex items-baseline justify-center space-x-1">
          {tier?.price === 0 ? (
            <span className="text-4xl font-bold text-foreground">Free</span>
          ) : (
            <>
              <span className="text-4xl font-bold text-foreground">${tier?.price}</span>
              <span className="text-muted-foreground">/month</span>
            </>
          )}
        </div>

        {tier?.books && (
          <div className="mt-2 flex items-center justify-center space-x-2">
            <Icon name="BookOpen" size={16} color="var(--color-muted-foreground)" />
            <span className="text-sm font-medium text-foreground">
              {typeof tier?.books === 'number' ? `${tier?.books} books` : tier?.books}
            </span>
          </div>
        )}
      </div>

      <Button
        variant={featured ? 'default' : tier?.price === 0 ? 'secondary' : 'outline'}
        size="default"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={() => onSelectPlan(tier?.id)}
        className="mb-6"
      >
        {tier?.price === 0 ? 'Start Free' : 'Get Started'}
      </Button>

      <div className="space-y-3 mb-6">
        {tier?.features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-2">
            <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <span className="text-sm text-foreground">{feature}</span>
          </div>
        ))}
      </div>

      {tier?.limitations?.length > 0 && (
        <div className="pt-4 border-t border-border space-y-2">
          {tier?.limitations?.map((limitation, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon name="X" size={16} color="var(--color-destructive)" className="flex-shrink-0 mt-0.5" />
              <span className="text-xs text-muted-foreground">{limitation}</span>
            </div>
          ))}
        </div>
      )}

      {tier?.upgradeNote && (
        <div className="mt-4 p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
            <p className="text-xs text-accent font-medium">{tier?.upgradeNote}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingTierCard;